import React, { useState } from 'react';
import ReactDOM from 'react-dom';
import { toast } from 'react-toastify';

const ControlModalList = ({ lights, onSave, onCancel }) => {
  const [controlData, setControlData] = useState({
    Key: "D8dX0dnZCkFMpd9uqna3GbPBI8xFh4id",
    LightType: 0,
    ControlMode: 0,
    ScheduleId: 1,
    GreenDuration: 20,
    YellowDuration: 5,
    RedDuration: 25,
    CycleTime: 60,
    selectedLight: null,
  });
  const [isLoading, setIsLoading] = useState(false);
  const [progress, setProgress] = useState(0);

  const handleSave = async () => {
    setIsLoading(true);
    setProgress(0);

    const controlDataList = lights.map((light) => ({
      DeviceId: light.id || 0,
      Key: controlData.Key,
      LightType: controlData.LightType,
      ControlMode: controlData.ControlMode,
      ScheduleId: controlData.ScheduleId,
      GreenDuration: controlData.GreenDuration,
      YellowDuration: controlData.YellowDuration,
      RedDuration: controlData.RedDuration,
      CycleTime: controlData.CycleTime,
      PriorityDirectionControl: controlData.selectedLight === '1' ? 1 : controlData.selectedLight === '2' ? 2 : 0,
    }));

    let allSuccess = true;
    for (let i = 0; i < controlDataList.length; i++) {
      const data = controlDataList[i];
      try {
        // Gọi onSave với callback để nhận kết quả từ onControlTrafficLight
        await new Promise((resolve, reject) => {
          onSave(data, (success) => {
            if (success) {
              resolve();
              setProgress(((i + 1) / controlDataList.length) * 100);
            } else {
              reject(new Error(`Không thể điều khiển đèn ${data.DeviceId}`));
            }
          });
        });
      } catch (err) {
        allSuccess = false;
        toast.error(`Lỗi: ${err.message}`, {
          position: 'top-center',
          autoClose: 5000,
        });
      }
    }

    if (allSuccess) {
      toast.success(`Điều khiển ${lights.length} đèn thành công!`, {
        position: 'top-center',
        autoClose: 3000,
      });
      onCancel(); // Đóng modal sau khi thành công
      
    } else {
      toast.error('Không thể điều khiển một số đèn. Vui lòng thử lại.', {
        position: 'top-center',
        autoClose: 3000,
      });
    }

    setIsLoading(false);
    setProgress(100);
  };

  const handleCancel = () => {
    console.log('Closing ControlModalList');
    onCancel();
  };

  return ReactDOM.createPortal(
    <div className="modal">
      <div className="modal-content">
        <div className="bg-blue-500 text-white p-2 rounded-t-lg">
          <h3 className="text-lg font-semibold mb-0">Điều khiển tuyến đường ưu tiên {lights.length} đèn</h3>
        </div>
        <div className="modal-body">
          <div className="mb-4">
            <h4 className="font-semibold">Danh sách đèn được chọn:</h4>
            {lights.map((light) => (
              <span key={light.id}>{light.name} ,</span>
            ))}
          </div>
          {progress > 0 && (
            <div className="mb-4">
              <div className="w-full bg-gray-200 rounded-full h-2.5">
                <div
                  className="bg-blue-600 h-2.5 rounded-full"
                  style={{ width: `${progress}%` }}
                ></div>
              </div>
              <p className="text-center text-sm mt-1">{Math.round(progress)}% hoàn thành</p>
            </div>
          )}
          <div className="grid grid-cols-2 gap-4">
            <div className="flex flex-col gap-1">
              <label className="font-bold text-gray-800 text-sm mb-0">Chuỗi xác thực</label>
              <input
                type="text"
                value={controlData.Key}
                disabled
                className="border p-2 rounded w-full bg-gray-100"
              />
            </div>
            <div className="flex flex-col gap-1 hidden">
              <label className="font-bold text-gray-800 text-sm mb-0">Chọn kết nối</label>
              <select
                value={controlData.LightType}
                onChange={(e) => setControlData({ ...controlData, LightType: parseInt(e.target.value) })}
                className="border p-2 rounded w-full"
              >
                <option value={0}>Tự động đồng bộ</option>
                <option value={1}>Cài qua RS485</option>
              </select>
            </div>
            <div className="flex flex-col gap-1">
              <label className="font-bold text-gray-800 text-sm mb-0">Chế độ điều khiển</label>
              <select
                value={controlData.ControlMode}
                onChange={(e) => setControlData({ ...controlData, ControlMode: parseInt(e.target.value) })}
                className="border p-2 rounded w-full"
              >
                <option value={0}>Tự động</option>
                <option value={1}>Ưu tiên</option>
              </select>
            </div>
            <div className="flex flex-col gap-1 col-span-2 hidden">
              <label className="font-bold text-gray-800 text-sm mb-0">ID lịch điều khiển</label>
              <input
                type="number"
                value={controlData.ScheduleId}
                onChange={(e) => setControlData({ ...controlData, ScheduleId: parseInt(e.target.value) || 1 })}
                className="border p-2 rounded w-full"
                min="1"
              />
            </div>
            {controlData.ControlMode === 1 && (
              <fieldset className="border rounded-lg p-4 col-span-2">
                <legend className="text-base font-semibold">Chế độ ưu tiên</legend>
                <div className="grid grid-cols-3 gap-4">
                  <label className="flex items-center">
                    <input
                      type="radio"
                      name="manualLightControl"
                      checked={controlData.selectedLight === '1'}
                      onChange={() =>
                        setControlData({ ...controlData, selectedLight: '1', PriorityDirectionControl: 1 })
                      }
                      className="mr-2"
                    />
                    Hướng A
                  </label>
                  <label className="flex items-center">
                    <input
                      type="radio"
                      name="manualLightControl"
                      checked={controlData.selectedLight === '2'}
                      onChange={() =>
                        setControlData({ ...controlData, selectedLight: '2', PriorityDirectionControl: 2 })
                      }
                      className="mr-2"
                    />
                    Hướng B
                  </label>
                </div>
              </fieldset>
            )}
            {controlData.ControlMode === 0 && (
              <fieldset className="border rounded-lg p-4 col-span-2">
                <legend className="text-base font-semibold">Cài đặt thời gian (chế độ tự động)</legend>
                <div className="grid grid-cols-3 gap-4">
                  <div className="flex flex-col gap-1">
                    <label className="font-bold text-gray-800 text-sm mb-0">Đèn xanh (tối đa 120s)</label>
                    <input
                      type="number"
                      value={controlData.GreenDuration}
                      onChange={(e) =>
                        setControlData({
                          ...controlData,
                          GreenDuration: Math.min(parseInt(e.target.value) || 1, 120),
                        })
                      }
                      className="border p-2 rounded w-full"
                      min="1"
                      max="120"
                    />
                  </div>
                  <div className="flex flex-col gap-1">
                    <label className="font-bold text-gray-800 text-sm mb-0">Đèn vàng (tối đa 15s)</label>
                    <input
                      type="number"
                      value={controlData.YellowDuration}
                      onChange={(e) =>
                        setControlData({
                          ...controlData,
                          YellowDuration: Math.min(parseInt(e.target.value) || 1, 15),
                        })
                      }
                      className="border p-2 rounded w-full"
                      min="1"
                      max="15"
                    />
                  </div>
                  <div className="flex flex-col gap-1">
                    <label className="font-bold text-gray-800 text-sm mb-0">Đèn đỏ (tối đa 135s)</label>
                    <input
                      type="number"
                      value={controlData.RedDuration}
                      onChange={(e) =>
                        setControlData({
                          ...controlData,
                          RedDuration: Math.min(parseInt(e.target.value) || 1, 135),
                        })
                      }
                      className="border p-2 rounded w-full"
                      min="1"
                      max="135"
                    />
                  </div>
                </div>
              </fieldset>
            )}
          </div>
          <div className="mt-4 flex justify-end space-x-2">
            <button
              onClick={handleSave}
              disabled={isLoading}
              className={`bg-green-500 text-white px-4 py-2 rounded hover:bg-green-600 ${
                isLoading ? 'opacity-50 cursor-not-allowed' : ''
              }`}
            >
              {isLoading ? 'Đang lưu' : 'Lưu'}
            </button>
            <button
              onClick={handleCancel}
              className="bg-gray-500 text-white px-4 py-2 rounded hover:bg-gray-600"
            >
              Đóng cửa sổ
            </button>
          </div>
        </div>
      </div>
    </div>,
    document.body
  );
};

export default ControlModalList;